// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"ShiftsTable_inputSearch__3pNOy"};